import type { ReactNode } from 'react';
import { useSyncExternalStore } from 'react';

import { UpdateRequired } from '@/components/templates/common/UpdateRequired/UpdateRequired';
import {
  getBuildRecoveryState,
  subscribeToBuildRecovery,
} from '@/utils/buildRecovery';

interface BuildRecoveryGateProps {
  children: ReactNode;
}

export function BuildRecoveryGate({ children }: BuildRecoveryGateProps) {
  const recoveryState = useSyncExternalStore(
    subscribeToBuildRecovery,
    getBuildRecoveryState,
    getBuildRecoveryState
  );

  if (recoveryState.status === 'terminal') {
    return <UpdateRequired />;
  }

  return children;
}
